(() => {
  const initHomeModule = (root) => {
    if (!root || root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';

  const reveals = root.querySelectorAll('.lmn-reveal');
  if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    reveals.forEach((item) => observer.observe(item));
  } else {
    reveals.forEach((item) => item.classList.add('is-visible'));
  }

  root.querySelectorAll('[data-lmn-compare]').forEach((compare) => {
    const range = compare.querySelector('.lmn-compare__range');
    range?.addEventListener('input', () => compare.style.setProperty('--position', `${range.value}%`));
  });

  root.querySelectorAll('.lmn-video-card').forEach((card) => {
    const video = card.querySelector('video');
    const button = card.querySelector('.lmn-video-card__toggle');
    if (!video || !button) return;
    button.addEventListener('click', () => {
      if (video.paused) {
        root.querySelectorAll('.lmn-video-card video').forEach((other) => {
          if (other !== video) other.pause();
        });
        root.querySelectorAll('.lmn-video-card__toggle span').forEach((label) => { label.textContent = 'Play'; });
        video.play();
        button.querySelector('span').textContent = 'Pause';
      } else {
        video.pause();
        button.querySelector('span').textContent = 'Play';
      }
    });
  });

  root.querySelectorAll('[data-lmn-quantity]').forEach((quantity) => {
    const input = quantity.querySelector('input');
    const buttons = quantity.querySelectorAll('button');
    buttons[0]?.addEventListener('click', () => { input.value = Math.max(1, Number(input.value || 1) - 1); });
    buttons[1]?.addEventListener('click', () => { input.value = Number(input.value || 1) + 1; });
  });

  root.querySelectorAll('.lmn-discover').forEach((discover) => {
    const tabCopies = Array.from(discover.querySelectorAll('.lmn-discover__tabs .lmn-responsive-copy'));
    const tabGroups = tabCopies
      .map((copy) => Array.from(copy.children).filter((item) => item.matches('span')))
      .filter((group) => group.length);
    const cards = Array.from(discover.querySelectorAll('.lmn-discover__grid > .lmn-product-card'));
    const grid = discover.querySelector('.lmn-discover__grid');
    const tabCount = Math.max(0, ...tabGroups.map((group) => group.length));
    if (!grid || !cards.length || tabCount < 2) return;

    tabCopies.forEach((copy) => copy.setAttribute('role', 'tablist'));
    grid.setAttribute('aria-live', 'polite');

    const groupForCard = (cardIndex) => {
      const baseSize = Math.floor(cards.length / tabCount);
      const remainder = cards.length % tabCount;
      let start = 0;
      for (let tabIndex = 0; tabIndex < tabCount; tabIndex += 1) {
        const size = baseSize + (tabIndex < remainder ? 1 : 0);
        if (cardIndex >= start && cardIndex < start + size) return tabIndex;
        start += size;
      }
      return tabCount - 1;
    };

    const activateTab = (activeIndex, moveFocus = false) => {
      tabGroups.forEach((group) => {
        group.forEach((tab, tabIndex) => {
          const active = tabIndex === activeIndex;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
          if (active && moveFocus && tab.offsetParent !== null) tab.focus({ preventScroll: true });
        });
      });
      cards.forEach((card, cardIndex) => {
        const active = groupForCard(cardIndex) === activeIndex;
        card.hidden = false;
        card.classList.toggle('is-tab-focus', active);
        card.style.order = active ? cardIndex : cards.length + cardIndex;
      });
      grid.scrollTo({ left: 0, behavior: 'smooth' });
    };

    tabGroups.forEach((group) => {
      group.forEach((tab, tabIndex) => {
        tab.setAttribute('role', 'tab');
        tab.setAttribute('aria-controls', grid.id || `discover-grid-${root.dataset.sectionId || 'home'}`);
        tab.addEventListener('click', () => activateTab(tabIndex));
        tab.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
          event.preventDefault();
          const direction = event.key === 'ArrowRight' ? 1 : -1;
          activateTab((tabIndex + direction + tabCount) % tabCount, true);
        });
      });
    });

    if (!grid.id) grid.id = `discover-grid-${root.dataset.sectionId || 'home'}`;
    const presetActive = tabGroups[0]?.findIndex((tab) => tab.classList.contains('is-active')) ?? 0;
    activateTab(presetActive >= 0 ? presetActive : 0);
  });
  };

  const initAll = (scope = document) => scope.querySelectorAll('.lmn-home').forEach(initHomeModule);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
